<article
    class="key-topic-two__container"
    [class.key-topic-two__container--credentials]="
        (!!author && author.type !== 'inline') || !!logo
    "
    [class.key-topic-two__container--insight]="!!author && author.type === 'inline'"
>
    @if (media && media.type === 'image') {
        <img
            [ngSrc]="media.path"
            [alt]="media.alt"
            nwTint
            [tint]="media.tint"
            [id]="'key-topic-two__container-image-' + media.id"
            width="600"
            height="400"
            class="key-topic-two__container__image"
        />
    }
    @if (media && media.type === 'video') {
        <nw-video
            [videoUrl]="media.path"
            [thumbnail]="media.poster"
            [altText]="media.alt"
            [duration]="media.duration"
        >
        </nw-video>
    }

    <div
        class="key-topic-two__container__content"
        [class.key-topic-two__container__content--left]="alignment === 'left'"
        [class.key-topic-two__container__content--center]="alignment === 'center'"
        [class.key-topic-two__container__content--right]="alignment === 'right'"
    >
        @if (step !== undefined) {
            <nw-pill class="key-topic-two__container__pill margin-bottom-m"
                ><span>Step {{ step }}</span></nw-pill
            >
        }
        <h3 class="key-topic-two__container__heading">
            <!-- data-slot: a role here would nest an ARIA heading/nav inside the real one. -->
            <ng-content select="[data-slot=heading], [role=heading]"></ng-content>
        </h3>
        @if (body) {
            <div>
                <span
                    class="key-topic-two__container__body"
                    [innerHTML]="body | sanitizeHtml"
                ></span>
                @if (tooltip) {
                    <nw-tooltip
                        class="key-topic-two__container__tooltip"
                        icon="circle-info"
                        [content]="tooltip"
                        [panelClass]="['tooltip-overlay-pane--narrow']"
                    ></nw-tooltip>
                }
            </div>
        } @else {
            <ng-content select="[role=body]"></ng-content>
        }
        <nav
            class="key-topic-two__container__link"
            #navRef
            [style.display]="hasNavigation$$() ? undefined : 'none'"
        >
            <ng-content select="[data-slot=nav], [role=nav]"></ng-content>
        </nav>

        @if (author) {
            <footer
                class="key-topic-two__container__author"
                [class.key-topic-two__container__author--inline]="
                    author.type === 'inline'
                "
            >
                @if (author.type !== 'inline') {
                    <p class="key-topic-two__container__author__name">
                        {{ author.name }}
                    </p>
                } @else {
                    <p class="key-topic-two__container__author--inline__name">
                        {{ author.name }}
                    </p>
                }
                <span class="key-topic-two__container__author__job">{{
                    author.jobTitle
                }}</span>
                @if (author.type !== 'inline') {
                    <nw-icon class="key-topic-two__container__author__quotes">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill
                            viewBox="0 0 24 24"
                            height="40px"
                            width="40px"
                            style="display: block"
                            preserveAspectRatio="xMidYMid meet"
                            focusable="false"
                        >
                            <path
                                fill="currentColor"
                                d="M22.5 13.875a5.623 5.623 0 0 1-5.625 5.625H16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h.375a2.627 2.627 0 0 0 2.625-2.625V13.5h-3c-1.655 0-3-1.345-3-3v-3c0-1.655 1.345-3 3-3h3c1.655 0 3 1.345 3 3v6.375Zm-12 0A5.623 5.623 0 0 1 4.875 19.5H4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h.375A2.627 2.627 0 0 0 7.5 13.875V13.5h-3c-1.655 0-3-1.345-3-3v-3c0-1.655 1.345-3 3-3h3c1.655 0 3 1.345 3 3v6.375Z"
                            />
                        </svg>
                    </nw-icon>
                }
            </footer>
        }
        @if (logo) {
            <img
                class="key-topic-two__container__logo margin-top-xl"
                [ngSrc]="logo.path"
                [alt]="logo.alt"
                height="20"
                width="200"
            />
        }
    </div>
</article>
